<template>
  <!-- 名人校友列表页面 -->
  <div class="liuguirencaiFile">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <img class="title" src="../../assets/images/名人校友.png" />
    <div class="information">
      <ul class="list_Oul">
        <li v-for="(item, index) in arrLIst" :key="index">
          <div class="marginauto">
            <img class="textbk" :src="item.Extend1" />
            <div class="abroadbox">
              <div class="abroadbox_title">
                <p class="p1">{{ item.Extend2 }}</p>
                <p class="p2">{{ item.Extend4 }}</p>
              </div>
              <p class="abroadbox_text">{{ item.Extend3 }}</p>
            </div>
          </div>
        </li>
      </ul>
      <a href="javascript:;" class="problem_more" @click="LoadMore">{{
        jzTxt
      }}</a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
export default {
  metaInfo() {
    return {
      title: `名人校友-东国概况-韩国东国大学中文官网`,
      meta: [
        {
          name: "keywords",
          content: "东国大学校友,名人校友,明星校友",
        },
        {
          name: "description",
          content:
            "韩国东国大学以新闻传媒,演艺界和文化界名人辈出的戏剧电影系和影像研究生院而闻名,培养了一大批优秀的毕业生和校友,活跃在传媒的各个领域.",
        },
      ],
    };
  },
  data() {
    return {
      jzTxt: "点击加载更多",
      imgUrl: "",
      arrLIst: [],
      isLoad: true,
      //分页
      pagination: {
        // 总条数
        total: 0,
        // 当前页码
        currentPage: 1,
        // 默认多少条数
        pagesize: 6,
      },
    };
  },
  activated() {
    this.$emit("handleTKD", "东国概况");
  },
  mounted() {
    this.getData();
  },
  methods: {
    //加载更多
    LoadMore() {
      if (!this.isLoad) return false;
      this.getData();
    },
    //初始化列表
    getData() {
      this.jzTxt = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 411,
          index: this.pagination.currentPage,
          size: this.pagination.pagesize,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst = this.arrLIst.concat(res.data.Data.list);
            this.imgUrl = res.data.Data.ImageServiceDoMain;
            //   // 加载状态结束
            this.jzTxt = "点击加载更多";
            //   // 数据全部加载完成
            if (this.arrLIst.length >= res.data.DataCount) {
              this.isLoad = false;
              this.jzTxt = "没有更多了";
            }
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
      this.pagination.currentPage++;
    },
  },
};
</script>

<style lang="scss" scoped>
.liuguirencaiFile {
  width: 750px;
  margin: 0 auto;
  padding: 0 40px;
  margin-top: 134px;
  padding-top: 60px;
  margin-bottom: 60px;
  .title {
    width: 157px;
    height: 38px;
    display: block;
    margin: 0 auto;
  }
  .information {
    width: 670px;
    margin: 0 auto;
    .list_Oul {
      li {
        width: 670px;
        background: #f8f8f8;
        margin-top: 40px;
        padding: 40px 0;
        .marginauto {
          width: 610px;
          height: 170px;
          margin: 0 auto;
          display: flex;
          .textbk {
            width: 170px;
            height: 170px;
            border-radius: 4px;
          }
          .abroadbox {
            width: 410px;
            margin-left: 30px;
            .abroadbox_title {
              display: flex;
              margin-top: -5px;
              .p1 {
                width: 100px;
                height: 40px;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 600;
                color: #333333;
                line-height: 48px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                word-break: break-all;
              }
              .p2 {
                margin-left: 10px;
                width: 300px;
                height: 40px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #f48729;
                line-height: 48px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                word-break: break-all;
              }
            }
            .abroadbox_text {
              margin-top: 20px;
              width: 410px;
              height: 112px;
              font-size: 26px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #444444;
              line-height: 40px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: normal;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
  /deep/.problem_more {
    display: block;
    font-size: 22px;
    color: #fff;
    background: #f48729;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin: 0 auto;
    margin-top: 50px;
    width: 100%;
    text-decoration: none;
    border-radius: 8px;
    letter-spacing: 1px;
  }
}
</style>